import ManageEvents from './manage-events'
export default ManageEvents
